import { Component,EventEmitter,Inject,Optional} from '@angular/core';
import { FormBuilder,Validators,ControlContainer,FormGroup  } from '@angular/forms';
import { Router } from '@angular/router';
import { TransfersFilterFormHelper,TransfersFilterFormState} from './transfers-filter-form.helper';
import { BaseFpxFormComponent,CriteriaQuery,ValidatorService } from '@fpx/core'; 
import { TransfersfilterService } from '../transfersfilter-service/transfersfilter.service';
import { Transfersfilter } from '../transfersfilter-service/transfersfilter.model';
import { TransfersMainService } from '../services/transfers-main.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IPopupScreenData } from 'src/app/common/models/popup-screen-data.model';
import moment from 'moment';
import { CommonService } from 'src/app/common.service';
import { API_DATE_FORMAT } from '@common/constants';

 
@Component({
 selector: 'app-transfers-filter-form',
  templateUrl: './transfers-filter-form.component.html',
  styleUrls: ['./transfers-filter-form.component.scss'],
  providers : [ TransfersFilterFormHelper]
  })

export class TransfersFilterFormComponent extends BaseFpxFormComponent<TransfersFilterFormHelper, TransfersFilterFormState> {
  constructor(
    @Optional() controlContainer: ControlContainer,
    formBuilder: FormBuilder,
    private router: Router,
    public transfersFilterFormHelper: TransfersFilterFormHelper,
    public transfersfilterService: TransfersfilterService,
    public transfersMainService:TransfersMainService,
    private validatorService: ValidatorService,

    private commonservice: CommonService,
    private _matDialogRef: MatDialogRef<TransfersFilterFormComponent>
    
  ) {
    super(formBuilder, router,controlContainer, transfersFilterFormHelper);
  }
   protected override doPreInit(): void {
   this.addFormControl('fromDate', '',  [Validators.required]   ,[],'change',1,false,0);			   		 
   this.addFormControl('toDate', '',  [Validators.required]   ,[],'change',1,false,0);	
	this.setDataService(this.transfersfilterService);
  }
  submitForm() {
    let fromDate = this.formGroup.get('fromDate').value;
    let toDate = this.formGroup.get('toDate').value;
    this.transfersMainService.transfersFilterData = this.formGroup.value
    const criteria:any = new CriteriaQuery();
    criteria.addFilterCritertia(
      this.state.instructionType === 'P'?'createdOn':"nextPaymentDate",
      'Timestamp',
      'inRange',
      {
        fromValue: fromDate+" "+"00:00:00",
        toValue: this.commonservice.getCurrentDateAsServerDate(toDate)
      });
    // criteria.addQueryparam('toDate', "2022-09-30");
    // this.transfersMainService.isTransafersHistoryAvailable = true;
      this._matDialogRef.close(criteria);
   }


   resetForm(){
    this.transfersMainService.transfersFilterData = undefined
    const criteria:any = new CriteriaQuery();
    this._matDialogRef.close(criteria);
   }
 

  protected override doPostInit(): void {
   
  }
  
}
